import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'src/components/Button';
import { DropdownMenu } from 'src/components/DropdownMenu';
import { messages } from 'src/messages';
import { LoginMembership, Website, WebsiteKind } from 'src/orchd-client';
import { useGetBrandingQuery } from 'src/store/branding/query';
import { useModal } from 'src/utils/modal/useModal';
import { PushLiveToNewModal } from '../Hero/PushLiveToNewModal';
import { PushLiveToExistingModal } from '../Hero/PushLiveToExistingModal';

interface Props {
  website: Website;
  member: LoginMembership;
}

export const CloneButton = ({ website, member }: Props) => {
  const isStagingWebsite = website.kind === WebsiteKind.staging;
  const { formatMessage } = useIntl();
  const { data: brandingData } = useGetBrandingQuery();
  const stagingDomain = brandingData?.stagingDomain;
  const showPushLiveToNewModal = useModal(PushLiveToNewModal);
  const showPushLiveToExistingModal = useModal(PushLiveToExistingModal);

  return (
    <DropdownMenu
      data-qa="pushLiveDropdown"
      button={
        <Button size="small" icon="chevron down" variant="secondary" iconPosition="right">
          {isStagingWebsite ? <FormattedMessage {...messages.push_live} /> : <FormattedMessage {...messages.clone} />}
        </Button>
      }
      options={[
        {
          label: formatMessage({
            id: 'website.hero.push_existing',
            defaultMessage: 'To an existing website',
          }),
          onClick: () =>
            showPushLiveToExistingModal({
              orgId: member.orgId,
              websiteId: website.id,
              isCloning: !isStagingWebsite,
            }),
        },
        {
          label: formatMessage({ id: 'website.hero.push_new', defaultMessage: 'To a new website' }),
          onClick: () =>
            showPushLiveToNewModal({
              member,
              websiteId: website.id,
              isCloning: !isStagingWebsite,
              stagingDomain,
            }),
        },
      ]}
    />
  );
};
